<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content #dialogContent>
  <p class="mat-body confirmation-content">
    {{content}}
  </p>
  <p *ngIf="details">{{details}}</p>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              [label]="cancelAction"></app-button>
  <span class="btn-spacer"></span>
  <app-button [destructive]="true"
              [disabled]="inProgress"
              (clicked)="proceed()"
              [label]="action"></app-button>
</div>
